import { render } from "./ProductPreview.vue?vue&type=template&id=cf3e501e&scoped=true"
import script from "./ProductPreview.vue?vue&type=script&lang=js"
export * from "./ProductPreview.vue?vue&type=script&lang=js"

import "./ProductPreview.vue?vue&type=style&index=0&id=cf3e501e&lang=scss&scoped=true"

import exportComponent from "D:\\FrontEndMentor Challenges\\Challenges\\Product-Preview-Component\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf3e501e"]])

export default __exports__